import { FETCH_PORTAL_DOMAINS, FETCH_DOMAIN, CREATE_DOMAIN, EDIT_DOMAIN, DELETE_DOMAIN } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PORTAL_DOMAINS:
      return action.payload
    case FETCH_DOMAIN:
      return [...state, action.payload]
    case CREATE_DOMAIN:
      return [...state, action.payload]
    case EDIT_DOMAIN:
      return state.map(domain => (domain.id === action.payload.id ? { ...domain, ...action.payload } : domain))
    case DELETE_DOMAIN:
      return state.filter(domain => domain.id !== action.payload)
    default:
      return state
  }
}
